import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import StaffManagementFilter from './components/StaffManagementFilter';
import StaffManagementTable from './components/StaffManagementTable';
import { PageTitle } from '../../components/Common/PageTitle';
import { EnumMerchantPermission, EnumPage } from '../../constants/enum';
import {
  changeFilters,
  changeTableActivePage,
  changeTablePageSize,
  closeDialogGeneric,
} from '../../redux/genericAction';
import {
  getListStaffRestaurant,
  openCreateStaffModal,
  updateStaff,
} from './actions';
import { getPermissionRestaurant, isEmptyObject } from '../../utils/utils';
import { trans } from '../../localization';
import StaffDetailModal from './StaffDetail/StaffDetailModal';
import { startConfirm } from '../../layout/components/UniversalModal/actions';
import { setCurrentRestaurant } from '../Setting/actions';

import './StaffManagement.scss';

class StaffManagement extends React.Component {
  componentDidMount() {
    const {
      handleChangeFiltersConnect,
      currentRestaurant,
      getListStaffRestaurantConnect,
    } = this.props;
    if (!isEmptyObject(currentRestaurant)) {
      const listRestaurantAllow = getPermissionRestaurant(
        this.props.restaurants,
        EnumMerchantPermission.STAFF_MANAGEMENT.id,
      );
      if (!isEmptyObject(listRestaurantAllow)) {
        if (
          listRestaurantAllow.find(
            restaurant =>
              restaurant.restaurant_id === currentRestaurant.restaurant_id,
          )
        ) {
          handleChangeFiltersConnect('restaurant', {
            label: currentRestaurant.name,
            value: currentRestaurant.restaurant_id,
          });
        } else {
          handleChangeFiltersConnect('restaurant', {
            label: listRestaurantAllow[0].name,
            value: listRestaurantAllow[0].restaurant_id,
          });
        }
      }
      getListStaffRestaurantConnect();
    }
  }

  render() {
    const {
      filters,
      restaurants,
      handleChangeFiltersConnect,
      changeTableActivePageConnect,
      table,
      changeTablePageSizeConnect,
      dialog,
      openCreateStaffModalConnect,
      closeDialogGenericConnect,
      getListStaffRestaurantConnect,
      updateStaffConnect,
      startConfirmConnect,
      setCurrentRestaurantConnect,
    } = this.props;
    const { isOpenDialog, itemDetail } = dialog;
    return (
      <React.Fragment>
        <PageTitle title={trans('set_staff_management')} />
        <StaffManagementFilter
          filters={filters}
          restaurants={restaurants}
          handleSearch={getListStaffRestaurantConnect}
          handleChangeFilters={handleChangeFiltersConnect}
          openCreateModal={openCreateStaffModalConnect}
          handleSetCurrentRestaurant={setCurrentRestaurantConnect}
        />
        <StaffManagementTable
          table={table}
          filters={filters}
          changeActivePage={changeTableActivePageConnect}
          changePageSize={changeTablePageSizeConnect}
          updateStaff={updateStaffConnect}
          startConfirm={startConfirmConnect}
          openUpdateStaffModal={openCreateStaffModalConnect}
        />
        <StaffDetailModal
          isOpenDialog={isOpenDialog}
          closeDialogGeneric={closeDialogGenericConnect}
          itemDetail={itemDetail}
          updateStaff={updateStaffConnect}
          filters={filters}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  restaurants: state.app.restaurants,
  currentRestaurant: state.setting.currentRestaurant,
  table: state.staff.table,
  filters: state.staff.filters,
  dialog: state.staff.dialog,
});

const mapDispatchToProps = (dispatch) => {
  const PAGE = EnumPage.SETTING_STAFF.id;
  return {
    closeDialogGenericConnect: () => {
      dispatch(closeDialogGeneric(PAGE));
    },
    handleChangeFiltersConnect: (name, value) => {
      dispatch(changeFilters(PAGE, name, value));
    },
    changeTableActivePageConnect: (activePage) => {
      dispatch(changeTableActivePage(PAGE, activePage));
    },
    changeTablePageSizeConnect: (pageSize) => {
      dispatch(changeTablePageSize(PAGE, pageSize));
    },
    getListStaffRestaurantConnect: () => dispatch(getListStaffRestaurant()),
    updateStaffConnect: body => dispatch(updateStaff(body)),
    openCreateStaffModalConnect: (staff) => {
      dispatch(openCreateStaffModal(staff));
    },
    setCurrentRestaurantConnect: (restaurant) => {
      dispatch(setCurrentRestaurant(restaurant));
    },
    startConfirmConnect: (title, message, onOk, onCancel) => {
      dispatch(
        startConfirm({
          title,
          message,
          onOk,
          onCancel,
        }),
      );
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(StaffManagement),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Staff/StaffManagement.jsx